import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'react-bootstrap-modal'

import TripForm from './../CreateTripForm'

export default class EditTripModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    trip: PropTypes.object,
    dates: PropTypes.array,
    user: PropTypes.object
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, dates, trip } = this.props

    return !!trip ? (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="trip-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <TripForm isTrip={this.props.isTrip} isFluid={true} dates={dates} trip={trip} user={this.props.user} onSave={() => onClose()} />
          <i className="trip-modal__close icon-close" onClick={() => onClose()} />
        </Modal.Body>
      </Modal>
    ) : null
  }
}



// WEBPACK FOOTER //
// src/components/TripPlanner/EditTripModal.js